import {useEffect, useState} from "react";
import isCancel from "../../services/http";
import httpServices from "../../services/http-services";
import {toast} from "react-toastify";
import Swal from "sweetalert2";

const useData = (apiEndpoint) => {
  const [data, setData] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const create = (entity) => {
    setLoading(true);
    httpServices
    .create(`/administrative${apiEndpoint}`, entity)
    .then(({data: {payload}}) => {
      setData((prevState) => [payload, ...prevState]);
      setLoading(false);
      toast.success("Successfully Saved!");
    })
    .catch((error) => {
      if (isCancel(error)) return;
      console.log(error);
      setError(error.message);
      setLoading(false);
      toast.error("Save Failed!");
    });
    return true;
  };

  const update = (entity, id) => {
    setLoading(true);
    httpServices
    .update(`/administrative${apiEndpoint}/${id}`, entity)
    .then((res) => {
      const updatedData = [...data];
      const index = updatedData.findIndex(item => item.id === id);
      updatedData.splice(index, 1, res.data.payload);
      setData(updatedData);
      setLoading(false);
      toast.success("Successfully Updated!");
    })
    .catch((error) => {
      if (isCancel(error)) return;
      console.log(error);
      setError(error.message);
      setLoading(false);
      toast.error("Update Failed!");
    });
  };

  const remove = (entityId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#354e80",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        httpServices
        .delete(`/administrative${apiEndpoint}`, entityId)
        .then(() => {
          const filterData = data.filter((item) => item.id !== entityId);
          setData(filterData);
          setLoading(false);
          toast.success("Successfully Deleted!");
        })
        .catch((error) => {
          if (isCancel(error)) return;
          console.log(error);
          setError(error.message);
          setLoading(false);
          toast.error("Delete Failed!");
        });
      }
    });
  };

  useEffect(() => {
    const {request, cancel} = httpServices.getAll(apiEndpoint);

    setLoading(true);
    request
    .then(({data: {payload}}) => {
      const allData = payload;
      setData(prevState => allData);
      setLoading(false);
    })
    .catch((error) => {
      if (isCancel(error)) return;
      console.log(error);
      setError(error.message);
      setLoading(false);
    });

    return () => cancel();
  }, [apiEndpoint]);

  return {data, isLoading, error, create, update, remove};
};

export default useData;
